module.exports = __webpack_public_path__ + "img/tahoe-21.a470c897.png";